import queryString from 'query-string';

import { ALLOWED_SUBMISSION_LIST } from '@constants/submission';

/**
 * Build transaction query search string
 * @param {string} transactionType - transaction type string.
 * @param {string} searchTerm - search term string
 * @returns {string}
 */
export const buildTransactionSearchString = (transactionType, searchTerm) => {
  const query = queryString.stringify({
    search: searchTerm,
    client_transaction_type: transactionType,
  });

  return query ? `?${query}` : '';
};

/**
 * gets button id for analytics
 * @param {string} pageName - page name string.
 * @param {string} componentName - component name.
 * @param {string} action - action name.
 * @returns {string}
 */
export const getButtonId = (pageName, componentName, action) =>
  `${pageName}-${componentName}_${action}`;

/**
 * Converts hex colours to rgb
 * @param {string} hex - hexadecimal colour string
 * @param {number} alpha - opacity value
 * @returns {string}
 */
export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

/**
 * Determines if submission actions should be shown or not.
 * @param {string} filingStatus - selected filing status
 * @returns {boolean}
 */
export const showSubmissionActions = filingStatus => ALLOWED_SUBMISSION_LIST.includes(filingStatus);
